export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGOUT = 'LOGOUT';

export const SIGNUP = 'SIGNUP';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';

export const NEWEVENT = 'NEWEVENT';
export const NEWEVENT_SUCCESS = 'NEWEVENT_SUCCESS';
export const NEWEVENT_FAILURE = 'NEWEVENT_FAILURE';

export const GETEVENTS = 'GETEVENTS';
export const GETEVENTS_SUCCESS = 'GETEVENTS_SUCCESS';
export const GETEVENTS_FAILURE = 'GETEVENTS_FAILURE';

export const SHOW_ALERT = 'SHOW_ALERT';
export const CLEAR_ALERT = 'CLEAR_ALERT';

export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js